import React, { useRef, useState } from "react";
import * as styles from "./SignUp.module.css";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { appConstants } from "../../utils";
import { IQ_HUB_AUTH_SERVICES } from "../../services";
import { signUpValidate } from "../../utils/validate";
import { FloatingInput } from "../Inputs";
import { OTPWithResendSubmit } from "../OTPComponents";
import { showToast } from "../ToastComponent";
import { useNavigate } from "react-router-dom";
import * as constant from "../../utils/constants";
import FloatingPassword from "../Inputs/FloatingPassword";

export const SignUp = ({ onLoginSuccess }) => {
  const userNameRef = useRef(null);
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const termsAndConditionsRef = useRef(null);

  const [isSignUpRequested, setisSignUpRequested] = useState(false);
  const [initialRetryTime, setInitialRetryTime] = useState(0);
  const [IsSignUpLoading, setIsSignUpLoading] = useState(false);
  const navigate = useNavigate();

  const handleLoginSuccess = async (credentialResponse) => {
    try {
      // Send token to backend for verification using fetch
      const response = await IQ_HUB_AUTH_SERVICES.IQGoogleLogin({
        token: credentialResponse.credential,
      });
      const data = await response.json();
      if (data.token) {
        localStorage.setItem(appConstants.IQ_HUB_TOKEN_NAME, data.token);
        if (onLoginSuccess) {
          onLoginSuccess(data.orgUserInfo);
        }
      }
      showToast(data?.message);
    } catch (error) {
      console.error("Google Authentication Failed:", error);
    }
  };

  const handleLoginError = () => {
    // console.error("Google Login Failed");
  };

  const handleSubmit = async () => {
    const payload = {
      name: userNameRef.current.value,
      email: emailRef.current.value,
      password: passwordRef.current.value,
      termsAndConditions: termsAndConditionsRef.current.value,
    };

    const message = signUpValidate(payload);
    if (message) {
      showToast(message);
      return;
    }

    setIsSignUpLoading(true);
    const response = await IQ_HUB_AUTH_SERVICES.SignUp(payload);
    const signUpData = await response.json();
    // if (response.status === 200) {
    //   showToast("Otp send To your mail");
    // }
    if (!response.status !== 200) {
      setisSignUpRequested(false);
    }
    switch (signUpData.message) {
      case "OTP_VERIFICATION_ALREADY_SENT":
      case "OTP_VERIFICATION_REQUIRED": {
        setisSignUpRequested(true);
        setInitialRetryTime(signUpData.retryDuration);
        break;
      }
      default: {
      }
    }
    showToast(signUpData.message);
    setIsSignUpLoading(false);
  };

  return (
    <div>
      {isSignUpRequested ? (
        <OTPWithResendSubmit
          initialRetryTime={initialRetryTime}
          otpVerifyAPI={IQ_HUB_AUTH_SERVICES.SignUpVerifyOtp}
          otpResendAPI={IQ_HUB_AUTH_SERVICES.SignUpResendOtp}
          onOTPVerified={() => {
            navigate(constant.APP_ROUTE_LOGIN);
          }}
        ></OTPWithResendSubmit>
      ) : (
        <form
          className={styles.form}
          onSubmit={(e) => {
            if (e.target.checkValidity()) {
              handleSubmit();
            }
            e.preventDefault();
          }}
        >
          <h1 className={styles.sign_in_Heading}>Sign Up</h1>
          <h3 className={styles.signup_h3}>
            Sign up to enjoy the feature of Avatars
          </h3>
          <FloatingInput
            label="Name"
            name="name"
            placeholder=""
            ref={userNameRef}
            type="text"
            required
          />

          <FloatingInput
            label="Email"
            name="email"
            placeholder=""
            ref={emailRef}
            type="email"
            required
          />

          <FloatingPassword ref={passwordRef} />

          <label className={styles.agreeToTerms}>
            <input
              type="checkbox"
              id="agree"
              required
              ref={termsAndConditionsRef}
            />
            &nbsp; &nbsp; I Agree to the terms and conditions
          </label>

          <button type="submit" className={styles.submit_button}>
            {IsSignUpLoading ? "Loading..." : "Send OTP >"}
          </button>

          <div className={styles.oauth_container}>
            <GoogleOAuthProvider
              clientId={appConstants.IQ_HUB_GOOGLE_CLIENT_ID}
            >
              <div className={styles.oauth_google_container}>
                <GoogleLogin
                  onSuccess={handleLoginSuccess}
                  onError={handleLoginError}
                />
              </div>
            </GoogleOAuthProvider>
          </div>

          <div className={styles.sign_up_container}>
            {`Already have an account??`}
            <a
              className={styles.sign_up}
              onClick={() => navigate(constant.APP_ROUTE_LOGIN)}
            >
              Sign in
            </a>
          </div>
        </form>
      )}
    </div>
  );
};
